export default __webpack_public_path__ + "static/media/w.c78146c4.jpg";